import { registerSW } from "virtual:pwa-register";
import { capture, captureException } from "@/posthog";
import { setWaitingWorker } from "@/utils/pwaUpdate";
import { setSnackbar } from "@/stores/ui";

function promptPwaUpdate(registration) {
  if (!registration?.waiting) return;

  setWaitingWorker(registration.waiting);
  setSnackbar({
    text: "Une nouvelle version est disponible.",
    color: "info",
    timeout: -1,
    actionText: "Actualiser",
    action: "pwa-reload",
  });
}

if (process.env.NODE_ENV === "production")
  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      console.log("Service worker has been registered.");
      promptPwaUpdate(registration);
    },
    onNeedRefresh() {
      console.log("New content is available; waiting for user confirmation.");
    },
    onOfflineReady() {
      console.log("App is ready to work offline.");
      capture("app_offline");
    },
    onRegisterError(error) {
      console.error("Error during service worker registration:", error);
      captureException(error, {
        flow: "service_worker",
      });
    },
  });

